import { isValid } from 'cpf';

const verifyCPF = (cpf: string) => {
  return isValid(cpf);
};

export default verifyCPF;
